import(/* webpackMode: "eager", webpackExports: ["DownloadLink"] */ "/vercel/path0/app/(marketing)/templates/_components/DownloadLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
